import { Basket } from 'entities/compilationContext/OnsiteCompilationContext/Basket';
import { OnsiteCompilationContext } from 'entities/compilationContext/OnsiteCompilationContext/OnsiteCompilationContext';
import { SampleBasket } from './SampleBasket';
import { createBasketCostsDefaultValues, createDiscountDefaultValues, createProductDefaultValues } from './utils';
import { ILocale } from 'entities/compilationContext/compilation-context';
import { IProduct } from 'entities/compilationContext/product';
import { SampleLocale } from './SampleLocale';
import { SampleProduct } from './SampleProduct';

type Wrapper = {
  compilationContext: OnsiteCompilationContext;
};

export class SampleOnsiteCompilationContext implements Wrapper {
  public constructor(
    basket: Basket,
    locale: ILocale,
    sendOverride: string,
    product: Pick<
      IProduct,
      'brand' | 'costs' | 'currency' | 'id' | 'metricId' | 'journey' | 'name' | 'url' | 'images' | 'currencySymbol'
    >,
    tagBag: Map<string, string>,
  ) {
    this.compilationContext = {
      basket,
      locale,
      sendOverride,
      product,
      tagBag,
    };
  }

  public static createDefaultSample() {
    return new SampleOnsiteCompilationContext(
      new SampleBasket({
        currency: 'basket.currency',
        currencySymbol: 'basket.currencySymbol',
        costs: createBasketCostsDefaultValues('basket.basketCosts'),
        discount: createDiscountDefaultValues('basket.discount'),
        items: [
          {
            product: createProductDefaultValues('basket.items.[0]'),
          },
        ],
        repopulationURL: 'basket.repopulationURL',
        type: 'basket.type',
      }),
      new SampleLocale({ code: 'locale.code', language: 'locale.language', region: 'locale.region' }),
      'sendOverride',
      new SampleProduct(createProductDefaultValues('', true)),
      new Map().set('myTag', 'tagBag.myTag'),
    );
  }

  public compilationContext: {
    basket: Basket;
    locale: ILocale;
    sendOverride: string;
    product: IProduct;
    tagBag: Map<string, string>;
  };
}
